import { render, staticRenderFns } from "./LgsProviderNew.vue?vue&type=template&id=20681500&"
import script from "./LgsProviderNew.vue?vue&type=script&lang=js&"
export * from "./LgsProviderNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports